import { render, staticRenderFns } from "./file_upolad.vue?vue&type=template&id=972cf166&scoped=true&"
import script from "./file_upolad.vue?vue&type=script&lang=js&"
export * from "./file_upolad.vue?vue&type=script&lang=js&"
import style0 from "./file_upolad.vue?vue&type=style&index=0&id=972cf166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972cf166",
  null
  
)

export default component.exports